/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import {
  CalculateDistancePointToLineDTO,
  DistanceStatusDtoModel
} from '@well/domain';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from 'rxjs';
import {PointDtoModel} from "@well/address-management-domain-model";

@Injectable({
  providedIn: 'root'
})
export class DistanceResourceService extends AbstractResourceService<any, any, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('distanceUrl'),
      undefined,
      undefined
    );
  }

  arePointAndLineWithin(point: PointDtoModel, line: PointDtoModel[], kmRange = 50): Observable<DistanceStatusDtoModel> {
    const distance: CalculateDistancePointToLineDTO = {
      point: point,
      line: line,
      kmRange: kmRange,
    };

    return this.httpClient?.post(`${this.url}/point-to-line/within`, distance)
      .pipe(this.getDtoMapper());
  }
}
